export var VELT_SDK_VERSION = '1.0.60';
